import { Grid, Typography } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import React, { Fragment } from "react";
import NumberFormat from "react-number-format";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
}));

export default function PaymentDetailListing(props) {
  const classes = useStyles();
  const { name = "", cardNumber = "", expirationDate = "" } = props.values;
  return (
    <Fragment>
      <List className={classes.root} dense>
        <Grid container>
          {/* <Grid item xs={12}>
            <ListItem>
              <ListItemText
                primary="Name on Card"
                secondary={
                  <Typography variant="h6" color="secondary">
                    {name}
                  </Typography>
                }
              />
            </ListItem>
          </Grid> */}
          <Grid item xs={12}>
            <Divider />
            <ListItem>
              <ListItemText
                primary="Card Number"
                secondary={
                  <Typography variant="h6" color="secondary">
                    <NumberFormat
                      value={cardNumber.replace(
                        cardNumber.substring(0, 12),
                        "************"
                      )}
                      format="**** **** **** ####"
                      displayType="text"
                    />
                  </Typography>
                }
              />
            </ListItem>
            <Divider />
          </Grid>
          {/* <Grid item xs={12}>
            <ListItem>
              <ListItemText
                primary="Expiry Date"
                secondary={
                  <Typography variant="h6" color="secondary">
                    <NumberFormat
                      value={expirationDate}
                      format="##/##"
                      placeholder="MM/YY"
                      mask={["M", "M", "Y", "Y"]}
                      displayType="text"
                    />
                  </Typography>
                }
              />
            </ListItem>
          </Grid> */}
        </Grid>
      </List>
    </Fragment>
  );
}
